module.exports = "pegasus_template/assets/background-patterns/theme2_theme.gif";